import React, { forwardRef, ReactNode } from 'react';
import { Box as ChakraBox, BoxProps } from '@chakra-ui/react';

interface Props extends BoxProps {
  children?: ReactNode;
}

export const Box = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraBox ref={ref} {...props}>
        {children}
      </ChakraBox>
    );
  }
);

export type { Props as BoxProps };
